import AuthHelper from './AuthHelper';

export default (componentWhenOwner, componentWhenNotOwner) => {
	if (!AuthHelper.isOwner()) {
		return componentWhenNotOwner;
	}

	return componentWhenOwner;
};
